import * as React from "react";
import FittedImage from "react-fitted-img";
import Helmet from "react-helmet";
import LeadershipBannerMobile from "../../assets/images/leadership/leadership-top-banner-mobile.png";
import LeadershipBanner from "../../assets/images/leadership/leadership-top-banner.png";
import Button from "../../components/Button/Button";
import StaticBanner from "../../components/StaticBanner/index";
import { Config } from "../../config/index";
import { AppContext } from "../../Context";
import { ComponentTheme } from "../../definitions/components";
import { IRootState } from "../../definitions/root";
import "./Leadership.css";
import team from "./LeadershipData";

const MemberImage = ({ name, src }) => (
  <FittedImage
    className="member-img"
    decoding="async"
    fit="cover"
    src={src}
    srcSet={`${src} 240w`}
    sizes="
      (min-width: 320px) 300px,
      (min-width: 768px) 320px,
      (min-width: 1024px) 360px,
      (min-width: 1200px) 420px
    "
    alt={`Our Team - ${name}`}
  />
);

export default function LeadershipPageRender() {
  return (
    <AppContext.Consumer>
      {({ app: { isMobile, isTablet } }: IRootState) => {
        const LeadershipBannerImage = !!isMobile || !!isTablet ? LeadershipBannerMobile : LeadershipBanner;
        return (
          <React.Fragment>
            <Helmet>
              <title>Leadership | Tabacalera USA</title>
              <link rel="canonical" href={`${Config.FRONT_END_URL}/leadership`} />
              <meta name="description" content={"Our Team"} />
            </Helmet>
            <div className="page page--our-team">
              <StaticBanner
                title={"Tabacalera Leadership"}
                bannerImg={{
                  fit: "cover",
                  src: LeadershipBannerImage,
                }}
              />

              <div className="member member-spotlight">
                <div className="container">
                  <div className="row middle-xs">
                    <div className="col-sm-4">
                      <MemberImage
                        name="Javier Estades Saez"
                        src={require("../../assets/images/leadership/javier-the-ceo.jpg")}
                      />
                    </div>
                    <div className="col-sm-8">
                      <div className="member-details">

                        <div className="heading">
                          <div className="title">Meet TUSA's CEO</div>
                          <p className="name">Javier Estades Saez</p>
                        </div>

                        <p className="bio">
                          Javier Estades Saez, President and CEO of TABACALERA USA Inc., is responsible for leading premium cigar operations in the United States, which include Altadis U.S.A., JR Cigar and Casa de Montecristo.
                        </p>

                        <Button
                          target={"_blank"}
                          rel={"noopener noreferrer"}
                          text={"LinkedIn"}
                          link={"https://www.linkedin.com/in/javier-estades-saez-johansson-b9003918/"}
                          theme={ComponentTheme.LIGHT} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="container">
                <div className="our-team-content">
                  <div className="members">
                    <div className="section-content-heading">
                      <h2 className="section-title">Our Executives</h2>
                    </div>
                    <div className="row">
                      {team.map(({ name, title, image, linkedIn}, i) =>
                        <div key={i} className="member col-xs-12 col-sm-4">
                          <MemberImage name={name} src={image}/>
                          <div className="member-details">
                            <p className="name">{name}</p>
                            <p className="job-title">{title}</p>
                            {!!linkedIn && <Button
                              target={"_blank"}
                              rel={"noopener noreferrer"}
                              link={`https://www.linkedin.com/in/${linkedIn}`}
                              text={"LinkedIn"}
                              theme={ComponentTheme.DARK} />}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </React.Fragment>
        );
      }}
    </AppContext.Consumer>
  );
}



// WEBPACK FOOTER //
// ./src/containers/Leadership/render.tsx